<template>
    <div>
        <div class="splash-screen">
            <!--<i class="close fa fa-times" @click="closeSplashScreen"></i> -->
            <header class="cabecera">
                <small class="subtitulo">
                    <strong>Procesando Información ...</strong>
                    <img  src="/img/loading.gif" class="procesar-screen"/>
                </small>
            </header>
            <section>
            </section>
        </div>
        <div class="sombra"></div>
    </div>

</template>

<script>
    const config = splash_config;
    export default {
        name: "ProcesandoScreen",
        methods:{
            closeSplashScreen(){
                this.$emit('close');
            },
        }
    }
</script>

<style scoped>

</style>
